import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';
import { ServerSideEnum } from './server-side-enum.model';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('GenAIProjectPromptType')
export class GenAIProjectPromptType extends ServerSideEnum {
  Empty: number;
  Transcript: number;
  SilenceDialog: number;
  Hold: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
